export enum TemplatesQueries {
	GET_ASPECT_RATIOS = `
    query AspectRatios {
        aspectRatios(
        
        where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
	GET_MEDIA_FORMATS = `
    query MediaFormats {
        mediaFormats(
        
        where: { active: { eq: true } }) {
            nodes {
                id
                code
                description
            }
        }
    }
    `,
	GET_CODIFIED_USES = `
    query CodifiedUses {
        codifiedUses(
            
            where: {
                active: { eq: true }
            }
        ) {
            nodes {
                id
                code
                description
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_CODIFIED_USEDS_BY_IDS = `
    query CodifiedUseds( $ids: [Int!]!) {
        codifiedUseds(
            
            where: {
                active: { eq: true }
                id: { in: $ids }
            }
        ) {
            nodes {
                id
                code
                description
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_SHOT_TYPES = `
    query ShotTypes {
        shotTypes(  order: {code: ASC}){
            nodes {
                id
                code
                name
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
                startCursor
                endCursor
            }
        }
    }
    `,
	GET_SHOT_COMBINATIONS = `
    query ShotCombinations( $mediaFormatId: Int!, $aspectRatioId: Int!) {
        shotCombinations(
            
            where: { active: { eq: true }, mediaFormatId: { eq: $mediaFormatId }, aspectRatioId: { eq: $aspectRatioId } }
        ) {
            nodes {
                id
                mediaFormatId
                codifiedUsedId
                aspectRatioId
                active
            }
        }
    }
    `,
	

	GET_TEMPLATES = `
    query Templates($where: TemplateDtiFilterInput, $first: Int, $after: String) {
        templates(
            where: $where,
            first: $first,
            after: $after
        ) {
            nodes {
                templateId
                templateName
                hasSizeGroup
                isDefault
                shotTypes {
                    templateId
                    sizeGroupId
                    sizeGroupName
                    ord
                    shotType {
                        id
                        label
                    }
                    aspectRatio {
                        id
                        label
                    }
                    mediaFormat {
                        id
                        label
                    }
                    codifiedUse {
                        id
                        label
                    }
                }
                styles {
                    templateId
                    modelId
                    styleCode
                    styleName
                    fullName
                    sketchImgPath
                }
                colors {
                    templateId
                    colorId
                    colorCode
                    colorName
                    fullName
                }
                category {
                    id
                    label
                }
                brand {
                    id
                    label
                }

            }
            totalCount
        }
    }
    `
}
